import React, { useEffect } from 'react';
import { branch, renderComponent } from 'recompose';
import redirect from 'lib/redirect';

const RedirectComponent = (props: { route: string }) => {
  const { route } = props;
  useEffect(() => {
    redirect(route);
  }, [route, props]);
  return <></>;
};

const withRedirect = (
  route: string | ((props: any) => string),
  condition: any,
) =>
  branch(
    condition,
    renderComponent(props => {
      const routeAsString = typeof route === 'function' ? route(props) : route;
      return <RedirectComponent route={routeAsString} />;
    }),
  );

export default withRedirect;
